<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 mt-2">
      <b-tabs>
        <b-tab
          :title="`${this.$t('menu.settings.accountData.customStatus')}`"
          active
        >
          <idx-card
            :title="`${this.$t('menu.settings.accountData.customStatus')}`"
          >
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <input
                    type="text"
                    class="form-control"
                    id="new-status"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.placeholderStatus',
                    )}`"
                  />
                  <button @click="addStatus" class="btn btn-primary">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="items" :fields="fields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-status-${row.item._id}`"
                        v-model="row.item.active"
                        @change="disableStatus(row.item._id, row.item.active)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-status-${row.item._id}`"
                      ></label>
                    </div>
                  </template>

                  <template v-slot:cell(name)="row">
                    <input
                      :id="`edit-status-name-${row.item._id}`"
                      type="text"
                      class="form-control"
                      style="display: none;"
                      :value="row.item.name"
                    />
                    <span
                      :id="`status-name-${row.item._id}`"
                      style="display: block;"
                    >
                      {{ row.item.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="text-center">
                      <button
                        :id="`status-save-${row.item._id}`"
                        class="btn btn-outline-info"
                        @click="saveStatus(row.item._id)"
                        style="display: none;"
                      >
                        <font-awesome-icon :icon="['fas', 'save']" />
                      </button>
                      <button
                        :id="`status-pen-${row.item._id}`"
                        @click="editStatus(row.item._id)"
                        class="btn btn-outline-primary"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`status-trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteStatus(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  components: { IdxCard },

  data: () => ({
    userAuth: null,
    fields: [],
    items: [],
  }),

  methods: {
    async deleteStatus(id) {
      try {
        await api.delete(`/delete-status/${id}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        swal('Sucesso', 'Status removido com sucesso', 'success');
        await this.getTreatmentStatus();
      } catch (error) {
        window.console.log(error);
      }
    },

    editStatus(index) {
      document.getElementById(`edit-status-name-${index}`).style.display =
        'block';
      document.getElementById(`status-name-${index}`).style.display = 'none';
      document.getElementById(`status-save-${index}`).style.display = 'inline';
      document.getElementById(`status-trash-${index}`).style.display = 'none';
      document.getElementById(`status-pen-${index}`).style.display = 'none';
    },

    async saveStatus(index) {
      const $input = document.getElementById(`edit-status-name-${index}`);
      $input.style.display = 'none';
      document.getElementById(`status-name-${index}`).style.display = 'block';
      document.getElementById(`status-save-${index}`).style.display = 'none';
      document.getElementById(`status-trash-${index}`).style.display = 'inline';
      document.getElementById(`status-pen-${index}`).style.display = 'inline';
      const newName = $input.value;

      if (newName !== '') {
        for (let i = 0; i < this.items.length; i += 1) {
          if (this.items[i].name === newName && this.items[i]._id !== index) {
            swal('Nome duplicado', 'error');
            $input.value = '';
            return;
          }
        }

        try {
          await api.patch(
            `/update-name-status/${index}`,
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso!', 'Nome atualizado com sucesso', 'success');

          await this.getTreatmentStatus();
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    async disableStatus(id, active) {
      try {
        await api.patch(
          `/update-status/${id}`,
          { active },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        if (active) {
          swal('Sucesso!', 'Habilitado com sucesso!', 'success');
        } else {
          swal('Sucesso!', 'Desabilitado com sucesso!', 'success');
        }

        await this.getTreatmentStatus();
      } catch (error) {
        window.console.log(error);
      }
    },

    async addStatus() {
      const $input = document.getElementById('new-status');
      const newName = $input.value;

      if (newName !== '') {
        for (let i = 0; i < this.items.length; i += 1) {
          if (this.items[i].name === newName) {
            swal('Error', 'Esse status já existe!', 'error');
            return;
          }
        }
        try {
          await api.post(
            '/create-status',
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso', 'Status de tratativa criado com sucesso!', 'success');
          await this.getTreatmentStatus();
        } catch (error) {
          window.console.log(error);
        }
        $input.value = '';
      }
    },

    async getTreatmentStatus() {
      try {
        const response = await api.get('/get-status', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.items = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getTreatmentStatus();
  },

  created() {
    this.fields = [
      {
        key: 'active',
        label: this.$t('menu.settings.accountData.labels.active'),
        sortable: true,
      },
      {
        key: 'name',
        label: 'Nome Status',
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('menu.settings.accountData.labels.action'),
      },
    ];
  },
};
</script>

<style scoped>
.input-area {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatments-status/index.vue